import axios from 'axios'
import { login } from './login'
import {
  getNetSuiteSalesOrder,
  getNetSuitePurchaseOrder,
  submitPickingSalesOrder,
  submitReceivingPurchaseOrder
} from './netsuite'
import { deleteUserCache } from './cache'
import { logout } from 'utils/auth'
import { addOrUpdateUser, getAllUser, deleteUser } from './user'
import {
  getUserActionsCount,
  getUserActionsByPaginationAndDate,
  downloadUserActionsExcel
} from './user-action'
import { updateRedisOrder, updateRedisTransferOrder } from './redis'
import {
  listSyncJobs,
  getSessionResults,
  downloadSessionResults
} from './sync-job'

axios.defaults.withCredentials = true
axios.defaults.baseURL = `${process.env.REACT_APP_BASE_SERVER_HOST}/api`
axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response) {
      const status = error.response.status
      const isAppAuthError =
        error.response.data?.error ===
        'User not authorized to perform this action'
      if (status === 401 && isAppAuthError) {
        alert('Unauthorized. Logging out...')
        logout()
      }
    }
    return Promise.reject(error)
  }
)

export {
  axios,
  login,
  getNetSuiteSalesOrder,
  getNetSuitePurchaseOrder,
  submitPickingSalesOrder,
  submitReceivingPurchaseOrder,
  deleteUserCache,
  addOrUpdateUser,
  getAllUser,
  deleteUser,
  getUserActionsCount,
  getUserActionsByPaginationAndDate,
  downloadUserActionsExcel,
  updateRedisOrder,
  updateRedisTransferOrder,
  listSyncJobs,
  getSessionResults,
  downloadSessionResults
}
